import React, { Component } from 'react';
import axios from "axios";
import QrScanner from 'qr-scanner';

import { IoIosSettings } from 'react-icons/io';
import { IoMdArrowRoundForward } from 'react-icons/io';

class RescanImages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            delay: 300,
            resolution: 1000,
            result: '',
            qrRead: false,
            qrCodeImage: '',
            qrReader: 1,
            step: 1,
            companyId: '',
            companyGroupId: '',
            companyName: '',
            eventId: '',
            lead: '',
            note: '',
            message: 'Scan QR Code',
            displayErrorBtn: false,
            displaySignInBtn: false,
            errorImageList: {},
            selectedImageName: 'test',
            rescanImagePath: '',
            rescanImage: '',
            rescanUserToken: '',
            availableCameras: [],
            currentCameraId: '',
            cameraFacingMode: 'environment',
            scanStatus: 'Searching for QR code',
        };

        this.handleError = this.handleError.bind(this);
        this.handleScan = this.handleScan.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleManualCameraSwitch = this.handleManualCameraSwitch.bind(this);
        this.handleAsyncUpdate = this.handleAsyncUpdate.bind(this);
        this.handleDecodeError = this.handleDecodeError.bind(this);
        this.admin = this.admin.bind(this);
        this.selectImage = this.selectImage.bind(this);
        this.getErrorImage = this.getErrorImage.bind(this);
        this.getImageList = this.getImageList.bind(this);
        this.postImageErrorLead = this.postImageErrorLead.bind(this);
        this.dismissLead = this.dismissLead.bind(this);

        this.textareaRef = React.createRef();
        this.videoRef = React.createRef();

        this.qrScanner = null;
        this.wait = null;
        this.isMountedFlag = false;
        this.lastNoQrStatusUpdate = 0;
        this.isStartingScanner = false;
    }

    async componentDidMount() {
        this.isMountedFlag = true;
        document.getElementById("app-window").focus();
        this.getImageList();

        if (this.state.step === 1) {
            await this.initializeScanner();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        void this.handleAsyncUpdate(prevProps, prevState);
    }

    componentWillUnmount() {
        this.isMountedFlag = false;

        if (this.wait) {
            clearTimeout(this.wait);
        }

        void this.destroyScanner();
    }

    async handleAsyncUpdate(prevProps, prevState) {
        if (this.state.step === 2 && prevState.step !== 2 && this.textareaRef.current) {
            this.textareaRef.current.focus();
        }

        if (prevState.step !== this.state.step) {
            if (prevState.step === 1 && this.state.step !== 1) {
                await this.destroyScanner();
            }

            if (prevState.step !== 1 && this.state.step === 1) {
                await this.destroyScanner();
                await this.initializeScanner();
            }
        }
    }

    handleInputChange(e) {
        const itemName = e.target.name;
        const itemValue = e.target.value;

        this.setState({ [itemName]: itemValue });
    }

    handleScan(lead) {
        if (!lead) {
            return;
        }

        this.setState({
            step: 2,
            result: lead,
            lead: lead,
            scanStatus: 'QR code detected',
        });
    }

    handleDecodeError() {
        const now = Date.now();

        if (
            now - this.lastNoQrStatusUpdate > 1000 &&
            this.isMountedFlag &&
            this.state.step === 1
        ) {
            this.lastNoQrStatusUpdate = now;
            this.setState({
                scanStatus: 'Searching for QR code',
            });
        }
    }

    handleError(err) {
        console.error(err);
    }

    isIosDevice() {
        const userAgent = window.navigator.userAgent;
        const isAppleMobile = /iPhone|iPad|iPod/i.test(userAgent);
        const isIpadDesktopMode =
            window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

        return isAppleMobile || isIpadDesktopMode;
    }

    canSwitchCamera() {
        return this.isIosDevice() || this.state.availableCameras.length > 1;
    }

    getPreferredCameraId(cameras, facingMode) {
        if (!Array.isArray(cameras) || cameras.length === 0) {
            return '';
        }

        const backRegex = /(back|rear|environment|trás|achter|后|bag)/i;
        const frontRegex = /(front|user|facetime|frente|vorne|前)/i;

        if (facingMode === 'user') {
            const frontCamera = cameras.find((camera) => frontRegex.test(camera.label));
            return frontCamera ? frontCamera.id : cameras[0].id;
        }

        const backCamera = cameras.find((camera) => backRegex.test(camera.label));
        if (backCamera) {
            return backCamera.id;
        }

        if (cameras.length > 1) {
            return cameras[cameras.length - 1].id;
        }

        return cameras[0].id;
    }

    async refreshCameraList() {
        try {
            const cameras = await QrScanner.listCameras(true);

            if (!this.isMountedFlag) {
                return;
            }

            const preferredCameraId = this.getPreferredCameraId(
                cameras,
                this.state.cameraFacingMode
            );

            this.setState((prevState) => ({
                availableCameras: cameras,
                currentCameraId: prevState.currentCameraId || preferredCameraId,
            }));
        } catch (error) {
            console.log(error);
        }
    }

    async initializeScanner() {
        if (this.state.step !== 1 || this.state.qrReader !== 1 || this.isStartingScanner) {
            return;
        }

        const videoElement = this.videoRef.current;
        if (!videoElement) {
            return;
        }

        try {
            this.isStartingScanner = true;

            this.setState({
                scanStatus: 'Scanner starting...',
            });

            const cameras = await QrScanner.listCameras(true);

            if (!this.isMountedFlag) {
                return;
            }

            if (!Array.isArray(cameras) || cameras.length === 0) {
                this.setState({
                    message: 'No camera found',
                    scanStatus: 'No camera found',
                });
                return;
            }

            const preferredCameraId = this.getPreferredCameraId(
                cameras,
                this.state.cameraFacingMode
            );

            this.qrScanner = new QrScanner(
                videoElement,
                (result) => {
                    const value =
                        result && typeof result === 'object' && 'data' in result
                            ? result.data
                            : result;

                    this.handleScan(value);
                },
                {
                    preferredCamera: this.isIosDevice()
                        ? this.state.cameraFacingMode
                        : preferredCameraId,
                    returnDetailedScanResult: true,
                    highlightScanRegion: false,
                    highlightCodeOutline: false,
                    maxScansPerSecond: 10,
                    onDecodeError: this.handleDecodeError,
                }
            );

            await this.qrScanner.start();

            this.setState({
                availableCameras: cameras,
                currentCameraId: preferredCameraId,
                scanStatus: 'Searching for QR code',
            });
        } catch (error) {
            console.log(error);

            if (this.isMountedFlag) {
                this.setState({
                    message: 'Camera could not be started',
                    scanStatus: 'Camera could not be started',
                });
            }
        } finally {
            this.isStartingScanner = false;
        }
    }

    async destroyScanner() {
        if (!this.qrScanner) {
            return;
        }

        try {
            await this.qrScanner.destroy();
        } catch (error) {
            console.log(error);
        } finally {
            this.qrScanner = null;
        }
    }

    async handleManualCameraSwitch() {
        if (!this.qrScanner) {
            return;
        }

        try {
            if (this.isIosDevice()) {
                const nextFacingMode =
                    this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';

                this.setState({
                    cameraFacingMode: nextFacingMode,
                    scanStatus: 'Switching camera...',
                    message: 'Scan QR Code',
                });

                await this.qrScanner.setCamera(nextFacingMode);

                if (!this.isMountedFlag) {
                    return;
                }

                this.setState({
                    scanStatus: 'Searching for QR code',
                });

                return;
            }

            const cameras =
                this.state.availableCameras.length > 0
                    ? this.state.availableCameras
                    : await QrScanner.listCameras(true);

            if (!Array.isArray(cameras) || cameras.length < 2) {
                return;
            }

            const currentIndex = cameras.findIndex(
                (camera) => camera.id === this.state.currentCameraId
            );

            const safeIndex = currentIndex >= 0 ? currentIndex : 0;
            const nextIndex = (safeIndex + 1) % cameras.length;
            const nextCamera = cameras[nextIndex];

            this.setState({
                currentCameraId: nextCamera.id,
                scanStatus: 'Switching camera...',
                message: 'Scan QR Code',
            });

            await this.qrScanner.setCamera(nextCamera.id);

            if (!this.isMountedFlag) {
                return;
            }

            this.setState({
                availableCameras: cameras,
                scanStatus: 'Searching for QR code',
            });
        } catch (error) {
            console.log(error);

            if (this.isMountedFlag) {
                this.setState({
                    message: 'Camera switch failed',
                    scanStatus: 'Camera switch failed',
                });
            }
        }
    }

    postImageErrorLead() {
        this.setState({ displayErrorBtn: false });

        var data = {};
        data.image_path = this.state.rescanImagePath;
        data.lead = this.state.lead;
        data.company_id = this.state.companyId;
        data.company_group_id = this.state.companyGroupId;
        data.token = this.props.token;
        data.rescan_user_token = this.state.rescanUserToken;
        data.event_id = this.props.eventId;

        this.setState({ message: 'Sending Lead' });
        this.setState({ step: 4 });

        console.log(data);

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=postImageErrorLead',
            data: JSON.stringify(data)

        }).then((responseObject) => {
            console.log(responseObject);

            if (responseObject.data.success === true) {
                this.props.connectionError(false);
                this.setState({ message: 'Lead has been registered' });

                this.wait = setTimeout(function () {
                    clearTimeout(this.wait);

                    this.setState({ message: '' });
                    this.setState({ note: '' });
                    this.setState({ step: 1 });
                    this.setState({ rescanImagePath: '' });
                    this.setState({ rescanImage: '' });
                    this.setState({ lead: '' });
                    this.setState({ scanStatus: 'Searching for QR code' });

                    this.getImageList();
                }.bind(this), 2000);

            } else {
                this.setState({ message: responseObject.data.result });
                this.setState({ displaySignInBtn: true });
            }

        }).catch((error) => {
            console.log(error);

            this.props.connectionError(true);
            this.setState({
                message: 'ERROR: Lead has NOT been registered. This may be due to a lack of internet connection!'
            });
            this.setState({ displayErrorBtn: true });
        });
    }

    dismissLead() {
        this.setState({ message: 'Lead has not been added' });
        this.setState({ step: 0 });

        this.wait = setTimeout(function () {
            clearTimeout(this.wait);

            this.setState({ note: '' });
            this.setState({ step: 1 });
            this.setState({ message: '' });
            this.setState({ lead: '' });
            this.setState({ scanStatus: 'Searching for QR code' });

        }.bind(this), 1000);
    }

    admin() {
        this.props.changeScreen('admin');
    }

    getImageList() {
        var data = {};
        data.lead = this.state.lead;
        data.note = this.state.note;
        data.token = this.props.token;
        data.event_id = this.props.eventId;

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=getErrorImagesList',
            data: JSON.stringify(data)

        }).then((responseObject) => {
            console.log(responseObject);
            this.setState({ errorImageList: responseObject.data });

        }).catch((error) => {
            console.log(error);
            this.props.connectionError(true);
        });
    }

    selectImage(key) {
        const image = this.state.errorImageList[key];
        this.setState({ selectedImageName: image });
        this.getErrorImage(image);
    }

    getErrorImage(image) {
        this.setState({ rescanImagePath: image });

        const imageArray = image.split('_');
        const eventId = imageArray[0];
        const companyId = imageArray[1];
        const rescanUserToken = imageArray[2];

        var data = {};
        data.image = image;
        data.company_id = companyId;
        data.token = this.props.token;

        console.log(data);

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=getErrorImage',
            data: JSON.stringify(data)

        }).then((responseObject) => {
            this.setState({ eventId: eventId });
            this.setState({ companyId: companyId });
            this.setState({ rescanUserToken: rescanUserToken });
            this.setState({ companyGroupId: responseObject.data.company.company_group_id });
            this.setState({ companyName: responseObject.data.company.company_name });
            this.setState({ rescanImage: responseObject.data.image });

        }).catch((error) => {
            console.log(error);
            this.props.connectionError(true);
        });
    }

    render() {
        const { companyId, companyName, initials, colors, logoTop, logoBottom } = this.props;

        const frontStyle = {
            color: colors.color_1,
            textShadow: '0px 4px 3px #00000030',
            whiteSpace: "pre-wrap"
        };

        const userStyle = {
            color: colors.color_1 + 'BB'
        };

        const btnStyle = {
            color: colors.color_1,
            backgroundColor: colors.color_2,
            cursor: 'pointer',
        };

        return (
            <div className="container-fluid d-flex align-items-center vh-100">
                <div className="row d-flex justify-content-center vh-100 vw-100">
                    <div className="content-wrapper page-home col-12 col col-sm-8 col-lg-6">

                        {logoTop !== '' &&
                            <div className="section-top-wrapper">
                                <img id="logo" src={logoTop} alt="Logo" />
                            </div>
                        }

                        <div className="content pt-2">
                            {this.state.message !== "" &&
                                <div
                                    id="message"
                                    className="mt-3 mb-3 text-center"
                                    style={frontStyle}
                                    dangerouslySetInnerHTML={{ __html: this.state.message }}
                                ></div>
                            }

                            {this.state.displayErrorBtn &&
                                <div className="text-center">
                                    <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.postImageErrorLead}>
                                        SEND AGAIN <IoMdArrowRoundForward />
                                    </button>
                                </div>
                            }

                            {this.state.displaySignInBtn &&
                                <div className="text-center">
                                    <button className="btn-medium m-2" type="button" style={btnStyle} onClick={() => this.props.changeScreen('setup', '')}>
                                        SIGN IN <IoMdArrowRoundForward />
                                    </button>
                                </div>
                            }

                            {this.state.qrReader === 1 && this.state.step === 1 &&
                                <div id="qr-wrapper" className="col-12 text-center">
                                    <div id="qr-container" style={{ width: '100%' }}>
                                        <video
                                            ref={this.videoRef}
                                            style={{
                                                width: '100%',
                                                minHeight: '320px',
                                                borderRadius: '16px',
                                                objectFit: 'cover',
                                                display: 'block',
                                            }}
                                            muted
                                            playsInline
                                        />

                                        <div style={{ marginTop: '10px' }}>
                                            <p style={frontStyle}>{this.state.scanStatus}</p>
                                        </div>

                                        {this.canSwitchCamera() &&
                                            <div className="text-center mt-2">
                                                <button
                                                    className="btn-medium m-2"
                                                    type="button"
                                                    style={btnStyle}
                                                    onClick={this.handleManualCameraSwitch}
                                                >
                                                    SWITCH CAMERA
                                                </button>
                                            </div>
                                        }

                                        <p style={frontStyle}>{this.state.lead}</p>
                                    </div>
                                </div>
                            }

                            {this.state.step === 2 &&
                                <div>
                                    <div className="mb-2" style={frontStyle}>Lead: {this.state.lead}</div>
                                    <div>
                                        <textarea
                                            className={"form-control pl-3"}
                                            rows="5"
                                            id="note"
                                            name="note"
                                            placeholder="note"
                                            defaultValue=""
                                            onChange={this.handleInputChange}
                                            ref={this.textareaRef}
                                        />
                                    </div>

                                    <div className="text-center mt-3">
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.dismissLead}>
                                            DISMISS <IoMdArrowRoundForward />
                                        </button>
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.postImageErrorLead}>
                                            SAVE <IoMdArrowRoundForward />
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>

                        {this.state.rescanImage !== '' && this.state.step === 1 &&
                            <div>
                                <div>{this.state.eventId}</div>
                                <div>{this.state.companyId}</div>
                                <div>{this.state.companyName}</div>
                                <img src={this.state.rescanImage} alt="Rescan Lead" width="600" />
                                <div className="mb-2">
                                    <strong>{this.state.selectedImageName}</strong>
                                </div>
                            </div>
                        }

                        {this.state.step === 1 &&
                            <div>
                                {Object.keys(this.state.errorImageList).map(key => (
                                    <div key={key} onClick={() => this.selectImage(key)}>
                                        {this.state.errorImageList[key]}
                                    </div>
                                ))}
                            </div>
                        }

                        <div className="section-bottom-wrapper mt-2">
                            {this.state.step === 1 &&
                                <div className="form-group text-center" style={userStyle}>
                                    <div id="user">
                                        <div>SIGNED IN AS</div>
                                        <div>Company: {companyName}</div>

                                        {initials !== '' &&
                                            <div>Initials: {initials}</div>
                                        }
                                    </div>

                                    {parseFloat(companyId) === 1 &&
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.admin}>
                                            Admin <IoIosSettings />
                                        </button>
                                    }

                                    {parseFloat(companyId) !== 1 &&
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.admin}>
                                            Menu <IoIosSettings />
                                        </button>
                                    }
                                </div>
                            }

                            {logoBottom !== '' &&
                                <div className="section-bottom-wrapper mt-5">
                                    <div className="text-center">
                                        <img id="logo-bottom" src={logoBottom} alt="Logo" />
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default RescanImages;